import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getJuntaDirectiva,
  deleteJuntaDirectiva,
  changeStatusJuntaDirectiva,
  changeOrderJuntaDirectiva,
} from "../../../../api/juntaDirectiva";
import { Button, Tooltip, Switch, FormControlLabel } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { SERVER_URL } from "../../../../api";

function getData(juntaDirectiva) {
  let data = [];
  for (let i = 0; i < juntaDirectiva.length; ++i) {
    const elem = {};
    elem.nombre = juntaDirectiva[i].nombre;
    elem.apellidos = juntaDirectiva[i].apellidos || "";
    elem.email = juntaDirectiva[i].email || "";
    elem.linkedin = juntaDirectiva[i].linkedin || "";
    elem.twitter = juntaDirectiva[i].twitter || "";
    elem.categoria = juntaDirectiva[i].categoria || "";
    elem.foto = juntaDirectiva[i].foto || "";
    elem.order = juntaDirectiva[i].order;
    elem.id = juntaDirectiva[i]._id;
    elem.active = juntaDirectiva[i].active;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.order - b.order);
  return data;
}

const initialFilters = {
  active: false,
};

export default function JuntaDirectivaPage() {
  const [data, setData] = useState([]);
  const [juntaDirectivaId, setJuntaDirectivaId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  async function cambiarOrden(cell, newOrder) {
    await changeOrderJuntaDirectiva(cell, newOrder);
  }
  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const handleSubtract = () => {
      setData((prevFilteredData) => {
        const currentJuntaDirectiva = prevFilteredData.find(
          (juntaDirectiva) => juntaDirectiva._id === cell
        );
        if (!currentJuntaDirectiva || currentJuntaDirectiva.order === 0)
          return prevFilteredData;

        const newOrder = currentJuntaDirectiva.order - 1;
        cambiarOrden(currentJuntaDirectiva._id, newOrder);

        const juntaDirectivaToSwap = prevFilteredData.find(
          (juntaDirectiva) => juntaDirectiva.order === newOrder
        );

        return prevFilteredData.map((juntaDirectiva) => {
          if (juntaDirectiva._id === cell) {
            return { ...juntaDirectiva, order: newOrder };
          }
          if (juntaDirectivaToSwap && juntaDirectiva._id === juntaDirectivaToSwap._id) {
            return { ...juntaDirectiva, order: currentJuntaDirectiva.order };
          }
          return juntaDirectiva;
        });
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setData((prevFilteredData) => {
        const currentJuntaDirectiva = prevFilteredData.find(
          (juntaDirectiva) => juntaDirectiva._id === cell
        );
        if (
          !currentJuntaDirectiva ||
          currentJuntaDirectiva.order === prevFilteredData.length - 1
        )
          return prevFilteredData;

        const newOrder = currentJuntaDirectiva.order + 1;
        cambiarOrden(currentJuntaDirectiva._id, newOrder);
        const juntaDirectivaToSwap = prevFilteredData.find(
          (juntaDirectiva) => juntaDirectiva.order === newOrder
        );

        return prevFilteredData.map((juntaDirectiva) => {
          if (juntaDirectiva._id === cell) {
            return { ...juntaDirectiva, order: newOrder };
          }
          if (juntaDirectivaToSwap && juntaDirectiva._id === juntaDirectivaToSwap._id) {
            return { ...juntaDirectiva, order: currentJuntaDirectiva.order };
          }
          return juntaDirectiva;
        });
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === data.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-junta-directiva/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setJuntaDirectivaId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setJuntaDirectivaId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  function imageFormatter(foto) {
    let src = foto ? `${SERVER_URL}/${foto}` : "";
    return foto ? <img src={src} width={50} height={50} style={{ objectFit: "cover", borderRadius: "50%" }}></img> : <div></div>;
  }

  const columns = [
    {
      dataField: "foto",
      text: "Foto",
      formatter: imageFormatter,
    },
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "apellidos", text: "Apellidos", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "categoria", text: "Categoría", sort: true },
    { dataField: "order", text: "Orden", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getJuntaDirectiva();
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      } catch (error) {
        alertError({
          error: error,
          customMessage: "Could not get junta directiva.",
        });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh, history]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de Junta Directiva">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-junta-directiva")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && !refreshOrder && (
            <Table data={getData(data)} columns={columns} />
          )}

          <ConfirmDialog
            title={`¿Estás seguro de que quieres ${
              juntaDirectivaId?.active ? "desactivar" : "activar"
            } este miembro de la junta directiva?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusJuntaDirectiva(juntaDirectivaId._id, !juntaDirectivaId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        juntaDirectivaId?.active ? "Desactivado!" : "Activado!"
                      }`,
                      customMessage: `Miembro de la junta directiva ${
                        juntaDirectivaId?.active ? "desactivado" : "activado"
                      } correctamente`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se pudo ${
                      juntaDirectivaId?.active ? "desactivar" : "activar"
                    } el miembro de la junta directiva.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar este miembro de la junta directiva?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteJuntaDirectiva(juntaDirectivaId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Eliminado!",
                      customMessage: "Miembro de la junta directiva eliminado correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se pudo eliminar el miembro de la junta directiva.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}

